/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {InputModule} from '../../../../shared/input/input.module';
import {PipesModule} from '../../../../shared/pipes/pipes.module';
import {ActiveInputModule} from '../active-input/active-input.module';
import {DecisionCodeModalComponent} from './decision-code-modal.component';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [DecisionCodeModalComponent],
    imports: [
        CommonModule,
        GenericModalModule,
        InputModule,
        PipesModule,
        ActiveInputModule,
        TooltipModule
    ]
})
export class DecisionCodeModalModule {
}
